export const baseURL = process.env.NODE_ENV === 'production'
  ? 'https://api.0x0z.com' : 'http://127.0.0.1:8080' // 请求的url地址baseUrl

export const CODE_OK = 0
export const CODE_ERR = -1
export const CODE_NO_LOGIN = -2
export const CODE_NOT_FOUND = -3

export default {
  baseURL
}



// WEBPACK FOOTER //
// ./src/request/config.js